export default __webpack_public_path__ + "static/media/Lively.76f54174.png";